<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';
    import MediaRow from '@/components/UI/Media/Row.vue';
    import MediaThumb from '@/components/UI/Media/Thumb.vue';

    export default {
        GalleryModal: defineAsyncComponent(() => import('@/components/UI/Media/GalleryModal.vue')),
        VerticalGalleryModal: defineAsyncComponent(() => import('@/components/UI/Media/VerticalGalleryModal.vue')),
        MediaRow,
        MediaThumb,
    }
</script>